(() => {
  'use strict';
  if(customElements.get('mb-media-gallery'))return;
  class MBMediaGallery extends HTMLElement {
    connectedCallback(){
      this.items=[...this.querySelectorAll('[data-media-id]')];
      this.thumbs=[...this.querySelectorAll('[data-target-media]')];
      this.thumbs.forEach(t=>t.addEventListener('click',()=>this.setActiveMedia(t.dataset.targetMedia,true)));
      this.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>this.step(-1));
      this.querySelector('[data-gallery-next]')?.addEventListener('click',()=>this.step(1));
      this.querySelectorAll('[data-media-zoom]').forEach(b=>b.addEventListener('click',()=>this.openZoom(b.dataset.mediaZoom)));
    }
    setActiveMedia(id,scroll=false){
      const target=this.items.find(i=>String(i.dataset.mediaId)===String(id));if(!target)return;
      this.items.forEach(i=>i.classList.toggle('is-active',i===target));
      this.thumbs.forEach(t=>{const on=String(t.dataset.targetMedia)===String(id);t.classList.toggle('is-active',on);t.setAttribute('aria-current',on?'true':'false');});
      if(scroll)target.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
      target.querySelector('video')?.play?.().catch(()=>{});
    }
    step(dir){const current=Math.max(0,this.items.findIndex(i=>i.classList.contains('is-active')));const next=(current+dir+this.items.length)%this.items.length;this.setActiveMedia(this.items[next]?.dataset.mediaId,true);}
    openZoom(id){const modal=document.getElementById(`ProductMediaModal-${this.dataset.section}`);if(!modal)return;modal.open?.(this.querySelector(`[data-media-zoom="${CSS.escape(String(id))}"]`));modal.querySelector(`[data-modal-media-id="${CSS.escape(String(id))}"]`)?.scrollIntoView({block:'center'});}
  }
  customElements.define('mb-media-gallery',MBMediaGallery);
})();
